/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { Tokens } from "@jda/lui-common-component-library-mui5";

export const useStyles = makeStyles((theme: Theme) => ({
  listWrapperStyle: {
    zIndex: 2,
    flexGrow: 1,
    position: "absolute",
    backgroundColor: theme.palette.background.default,
  },
  listPanel: {
    flexDirection: "column",
    border: "1px solid #e0e0e0",
    backgroundColor: theme.palette.grey["50"],
  },
  listView: {
    zIndex: 1,
    overflow: "scroll",
    position: "absolute",
    flexDirection: "column",
    marginTop: theme.spacing(0.5),
    boxShadow: "0px 0px 16px 0px rgba(0,0,0,0.2)",
    backgroundColor: theme.palette.background.paper,
  },
  selectedListItem: {
    width: theme.spacing(50),
    borderBottom: "1px solid #e0e0e0",
    backgroundColor: Tokens.colors.lightTheme.codeEditor.variableParameter,
    "&:hover": {
      backgroundColor: Tokens.colors.lightTheme.codeEditor.variableParameter,
    },
    "& span": {
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    }
  },
  listItem: {
    paddingLeft: theme.spacing(0),
    width: theme.spacing(50),
    borderBottom: "1px solid #e0e0e0",
    "&:hover": {
      backgroundColor: theme.palette.grey,
    },
    "& span": {
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    }
  },
  listItemText: {
    paddingLeft: theme.spacing(2),
  },
  noItemsFound: {
    alignContent: "center",
    justifyContent: "center",
    width: theme.spacing(50),
    height: theme.spacing(5),
    paddingLeft: theme.spacing(2),
  },
  noItemsFoundText: {
    fontSize: "0.875rem",
    color: theme.palette.text.secondary,
  }
}));
